export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7017851f3d419437be21c89ca27dad13adc6debfc2&name=pushAdClickData!'